import React,{useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import './RegisterPage.css'
import Card from '@mui/material/Card';
import RegisterNewUserModal from './RegisterNewUserModal';

const RegisterPageFree = () => {

  const [registerComplete,setRegisterComplete]=useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!registerComplete) {
      setIsRegisterModalOpen(true);
    }
  }, [registerComplete]);

  const handleRegister = (value:boolean) => {
    setRegisterComplete(value);
  };

  return <>
  <section className='flex justify-center items-center h-full register-section-1'>
     <Card sx={{ minWidth: 275, padding:'2rem' }} className="card-register">
    <div className="flex flex-col justify-center items-center gap-5 py-6">
      <div className="py-2">
        <img src="../../assets/icons/Logo/Logo-sm.png" width={64} alt="Logo" />
      </div>
      <p className="text-center text-sb-900 font-[DIN-Condensed] text-lg">
        Registro de nuevo usuario
      </p>
      <button
        className="button-30 w-fit p-2"
        onClick={() => setIsRegisterModalOpen(true)}
      >
        Abrir registro
      </button>
    </div>
     {registerComplete ? '':( <div className="flex justify-center py-2">
          <h6 className='text-lg uppercase font-[DIN-Condensed] text-sb-500 cursor-pointer  hover:text-so-500 hover:scale-110' onClick={() => navigate('/login')}>
            Ya tengo Usuario
          </h6>
       </div>)}
    </Card>
    <div className="flex justify-center bg-sb-600">
    </div>
        
  </section>

  <RegisterNewUserModal
    isOpen={isRegisterModalOpen}
    onClose={() => setIsRegisterModalOpen(false)}
    onRegisterSuccess={handleRegister}
  />
  
  </>
}

export default RegisterPageFree

